import { combineReducers, createFeatureSelector } from '@ngrx/store';

import type { GetConsentsState } from './get-consents/get-consents.reducer';
import { consentGroupReducer } from './get-consents/get-consents.reducer';
import { consentPackageView } from './consent-package-view/consent-package-view.reducer';
import type { ConsentContainerRendering, ConsentForm } from '../models';
import { ConsentFormReducer } from './form/consent-form.reducer';
import { consentRendering } from './consent-rendering/consent-rendering.reducer';

export const consentSelectorKey = 'consent';

export interface ConsentState {
  rendering?: ConsentContainerRendering;
  packageView: boolean;
  consentGroups: GetConsentsState;
  consentForm: ConsentForm;
}

export const consentReducers = combineReducers<ConsentState>({
  rendering: consentRendering,
  packageView: consentPackageView,
  consentGroups: consentGroupReducer,
  consentForm: ConsentFormReducer,
});

export const selectConsentState =
  createFeatureSelector<ConsentState>(consentSelectorKey);
